import { Pipe, PipeTransform } from '@angular/core';
 
@Pipe({
  name: 'customCurrency'
})
export class CustomCurrencyPipe implements PipeTransform {
 
  transform(value: string | number, ...args: unknown[]): string {
    if (typeof value === 'string') {
      value = value.replace(/,/g, '').replace(/\./g, '');
      value = parseFloat(value);
    }
 
    if (isNaN(value)) {
      return '';
    }
 
    const formattedValue = new Intl.NumberFormat('es-CO', {
      style: 'currency',
      currency: 'COP',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(value);
 
    return formattedValue;
  }
}